/**
 * Created by RaoMeng on 2018/11/7
 * Desc: 班级相册
 */

import React, {Component} from 'react'
import ReactDOM from 'react-dom'
import AlbumItem from 'components/AlbumItem'
import {getIntValue, getStrValue, isObjEmpty} from "../../utils/common";
import {Icon} from 'antd'
import {Picker, List, Toast} from 'antd-mobile'
import {fetchGet, fetchPost} from "../../utils/fetchRequest";
import {_baseURL, API} from "../../configs/api.config";
import ClassBean from 'model/ClassBean'
import AlbumBean from "../../model/AlbumBean";
import {connect} from 'react-redux'
import {saveClassData} from "../../redux/actions/classData";
import {saveListState} from "../../redux/actions/listState";

const uploadItem = new AlbumItem()
uploadItem.coverImg = 'upload'
uploadItem.albumName = '新建相册'
uploadItem.quantity = -1

class ClassAlbum extends Component {

    constructor() {
        super()

        this.state = {
            albumList: [],
            classList: [],
            classValue: []
        }
    }

    componentWillMount() {
        if (this.props.match.params.type) {
            this.mType = this.props.match.params.type
        }

        this.initAlbumList()

    }

    componentDidMount() {
        console.log(this.props.listState)
        document.title = '班级相册'
        this.container.scrollIntoView();

        if (isObjEmpty(this.props.classData.classList)) {
            Toast.loading('', 0)
            this.getClassList()
        } else {
            const {classValue} = this.state
            if (isObjEmpty(this.props.classData.classValue)) {
                classValue.push(this.props.classData.classList[0].value)
            }
            this.setState({
                classList: this.props.classData.classList,
                classValue: this.props.classData.classValue,
            }, () => {
                Toast.loading('获取相册中...', 0)
                this.getAlbumList(this.state.classList[this.state.classValue])
            })
        }
    }

    componentWillUnmount() {
        Toast.hide()
    }

    render() {
        const {albumList, classList, classValue} = this.state

        let albumItems = []
        if (!isObjEmpty(albumList)) {
            for (let i = 0; i < albumList.length; i++) {
                const albumBean = albumList[i]
                if (!isObjEmpty(albumBean)) {
                    albumItems.push(
                        <AlbumItem
                            albumBean={albumBean}
                            itemClick={this.onItemClick.bind(this)}
                            index={i}/>
                    )
                }
            }
        }
        return (
            <div ref={node => this.container = node} style={{height: '100vh', overflow: 'scroll'}}>
                <div className='gray-line'></div>
                <Picker data={classList} title='选择班级' extra='请选择'
                        value={classValue} onChange={this.handleClassChange} cols={1}>
                    <List.Item arrow="horizontal">选择班级</List.Item>
                </Picker>
                <div className='gray-line'></div>
                <div style={{padding: '20px'}}>
                    {albumItems}
                </div>
            </div>
        )
    }

    getClassList = () => {
        const {classList, classValue} = this.state
        classList.length = 0

        let userRole = this.props.userInfo.userRole;
        let params, url
        if (userRole == 1) {
            url = API.GET_STU_CLASS_LIST
            params = {
                stuId: this.props.userInfo.user.student.stuId
            }
        } else {
            url = API.GET_CLASS_LIST
            params = {
                teacherId: this.props.userInfo.user.userFunId
            }
        }
        fetchGet(url, params).then(response => {
            Toast.hide()

            this.analysisClassList(response)
        }).catch(error => {
            Toast.hide()

            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('班级获取异常', 2)
            }
        })
    }

    getAlbumList = classBean => {
        this.initAlbumList()

        fetchPost(API.GET_ALBUM_LIST, {
            clazzId: classBean.schId,
            albumStatus: 1,
            albumType: 1,
            pageIndex: 1,
            pageSize: 100,
        }).then(response => {
            Toast.hide()

            const {albumList} = this.state
            let dataArray = response.data
            if (dataArray) {
                for (let i = 0; i < dataArray.length; i++) {
                    let dataObject = dataArray[i]
                    if (dataObject) {
                        let albumBean = new AlbumBean()

                        albumBean.albumId = getStrValue(dataObject, 'albumId')
                        albumBean.coverImg = getStrValue(dataObject, 'albumUrl') ?
                            getStrValue(dataObject, 'albumUrl') : ''
                        albumBean.albumName = getStrValue(dataObject, 'albumTitle')
                        albumBean.quantity = getIntValue(dataObject, 'albumCount')
                        albumBean.albumDate = getStrValue(dataObject, 'createDate')
                        albumBean.type = getStrValue(dataObject, 'albumType')
                        albumBean.status = getStrValue(dataObject, 'albumStatus')
                        albumBean.remarks = getStrValue(dataObject, 'albumRemarks')
                        // albumBean.gradeId = getStrValue(dataObject, 'parentId')
                        albumBean.classId = getStrValue(dataObject, 'clazzId')
                        // albumBean.classname = getStrValue(dataObject, 'schName')

                        albumList.push(albumBean)
                    }
                }
                this.setState({albumList}, () => {
                    if (this.props.listState) {
                        ReactDOM.findDOMNode(this.container).scrollTop = this.props.listState.scrollTop
                    }
                })
            }
        }).catch(error => {
            Toast.hide()
            if (typeof error === 'string') {
                Toast.fail(error)
            }
        })
    }

    onItemClick = (index) => {
        const {classList, classValue, albumList} = this.state

        saveClassData({
            classList: classList,
            classValue: classValue,
        })()
        console.log('dd', ReactDOM.findDOMNode(this.container))
        saveListState({
            scrollTop: ReactDOM.findDOMNode(this.container).scrollTop,
        })()
        if (index == 0 && this.mType == 'teacher') {
            let classId = -1
            let classname = ''
            if (classList[classValue]) {
                classId = classList[classValue].schId
                classname = classList[classValue].label
            }
            this.props.history.push('/newAlbum/' + classId + '/' + classname)
        } else {
            this.props.history.push('/pictureList/' + this.mType + '/' + getStrValue(albumList[index], 'albumId')
                + '/' + this.state.albumList[index].albumName)
        }
    }

    handleClassChange = (v) => {
        this.setState({classValue: v})
        this.getAlbumList(this.state.classList[v])
    }

    initAlbumList = () => {
        const {albumList} = this.state
        albumList.length = 0
        if (this.mType == 'parents') {
        } else if (this.mType == 'teacher') {
            this.setState({
                albumList: [uploadItem]
            })
        }
    }

    analysisClassList = response => {
        const {classList, classValue} = this.state
        classList.length = 0
        classValue.length = 0

        let dataArray = response.data
        if (dataArray) {
            for (let i = 0; i < dataArray.length; i++) {
                let dataObject = dataArray[i]
                if (dataObject) {
                    let classBean = new ClassBean()

                    classBean.label = getStrValue(dataObject, 'gradeName') + getStrValue(dataObject, 'clazzName')
                    classBean.value = i
                    classBean.schId = getStrValue(dataObject, 'clazzId')
                    classBean.parentId = getStrValue(dataObject, 'gradeId')
                    classBean.schName = getStrValue(dataObject, 'clazzName')
                    classBean.schStatus = getStrValue(dataObject, 'clazzStatus')
                    classBean.schRemarks = getStrValue(dataObject, 'clazzRemarks')
                    classBean.grade = getStrValue(dataObject, 'gradeName')

                    classList.push(classBean)
                }
            }

            if (classList.length > 0) {
                classValue.push(classList[0].value)
                this.setState({
                    classList,
                    classValue
                })

                Toast.loading('获取相册中...', 0)
                this.getAlbumList(classList[0])
            }
        }
    }
}

let mapStateToProps = (state) => ({
    userInfo: {...state.redUserInfo},
    listState: {...state.redListState},
    classData: {...state.redClassData}
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(ClassAlbum)